module.exports = __webpack_public_path__ + "static/media/activate-card-icon.4a810741.png";